import React from 'react';
import { Mail } from 'react-feather';
import { Trans, useTranslation } from 'react-i18next';

import { Modal } from '@/components';

import styles from './Modals.module.css';

interface EmailVerificationModalProps {
  onClose: () => void;
  onRetry: () => void;
}

function EmailVerificationModal({ onClose, onRetry }: EmailVerificationModalProps) {
  const { t } = useTranslation();

  return (
    <Modal modalStyles={{ maxWidth: '480px' }} handleClose={onClose}>
      <div className={styles.modal}>
        <Mail color="black" width={32} height={32} className={styles.mb16} />
        <h2 className={`${styles.modalTitle} ${styles.mb16}`}>
          {t('account.verification.emailTitle')}
        </h2>
        <div className={`${styles.modalDescription} ${styles.mb40}`}>
          {t('account.verification.emailDescription')}
        </div>

        <span className={styles.footer}>
          <Trans
            i18nKey="signup.step3.info"
            components={{
              1: <span onClick={onRetry} />
            }}
          />
        </span>
      </div>
    </Modal>
  );
}

export default EmailVerificationModal;
